// src/pages/hr/HREmployeeServices.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HREmployeeServices() {
  return (
    <HRComingSoon
      icon="🛠️"
      title="Employee Services"
      description="HR Help Desk, support tickets, ESS/MSS portal management, company announcements, events calendar, and employee rewards & recognition. Coming soon."
    />
  );
}
